import { css, cva } from '@/styled-system/css';

// cva + .raw() so Modal.Content's css prop merges these instead of concatenating class names
export const drawerRecipe = cva({
  base: {
    position: 'fixed',
    // offset below the IA top bar when present (var published on :root by AppLayoutContainer;
    // 0 otherwise) so the drawer header (prev/next + close) clears the fixed bar
    top: 'var(--ia-topnav-total-height, 0px)',
    // logical properties so these merge on the same key as Modal.Content's own block/inline-size, rather
    // than racing them as separate physical-vs-logical atomics
    blockSize: 'calc(100vh - var(--ia-topnav-total-height, 0px))',
    inlineSize: '720px',
    maxInlineSize: '100vw',
    backgroundColor: 'bg.neutral',
    boxShadow: 'lg',
    zIndex: '1000',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: 0,

    '@media (max-width: 768px)': {
      inlineSize: '100vw',
    },
  },
  variants: {
    alignment: {
      left: {
        left: 0,
        right: 'unset',
      },
      right: {
        right: 0,
        left: 'unset',
      },
    },
  },
  defaultVariants: {
    alignment: 'right',
  },
});

export const drawerBodyStyles = css.raw({
  flex: 1,
  overflow: 'auto',
  paddingTop: 'default',
  paddingInline: 'default',
});
